import React, { useMemo } from "react";
import * as S from "./CmpTextInput.style";
import Popup from "reactjs-popup";
import { useTranslation } from "react-i18next";
import { PopUpPayload } from "../genericTemplate/GenericTemplate.style";

// pipes
import * as P from "../../../../../../../utils/pipes";

// Components
import FlorenzInput from "../../../../../../florenzComponents/florenzInput";

function CmpTextInput({
  item,
  insertfunction,
  customFormChangeItem,
  typeView
}) {  
  const { i18n: { language } } = useTranslation("global");

  const changeOptionItem = (value) => {
    const userToCustomFormField = {
      customFormFieldParentId: item?.customFormFieldParentId,
      customFormFieldId: item.id,
      value: value.toString(),
      key: value.toString()
    }
    insertfunction(userToCustomFormField);
  }

  const displayValue = useMemo(() => {
    return customFormChangeItem && customFormChangeItem.value.toString();
  }, [customFormChangeItem]);

  return (
    <S.CmpTextInput>
      <div className="selection-container">
        <div className="title">
          <div className="title__text">
            {item.fieldName && P.dataTranslation(item.fieldName, language)}
          </div>
          {
            displayValue
            ? <i className="title__icon icon zaia-i-check-1"></i>
            : <div className="title__required error">{!item.optional && "*"}</div>
          }
          <Popup
            trigger={
              <i className="title__icon-payload icon zaia-alert"></i>
            }
            on={['hover', 'focus']}
            closeOnDocumentClick
            keepTooltipInside
            position={['right center']}
            nested
          >
            <PopUpPayload>
              <p>
              {P.dataTranslation(item.descript, language)}
              </p>
            </PopUpPayload>
          </Popup>
        </div>
        <div className="input-container">
          <FlorenzInput
            value={displayValue}
            getText={changeOptionItem}
            type={"text"}
            disabled={typeView === 'view'}
          />
        </div>
      </div>
    </S.CmpTextInput>
  );
}

export default CmpTextInput;
